/**
 * @generated SignedSource<<9e755d08cdeb5384ad4a866afd9d5e36>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type postHeader_deletePostMutation$variables = {
  id: string;
};
export type postHeader_deletePostMutation$data = {
  readonly deletePost: {
    readonly id: string;
  };
};
export type postHeader_deletePostMutation = {
  response: postHeader_deletePostMutation$data;
  variables: postHeader_deletePostMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "postHeader_deletePostMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Post",
        "kind": "LinkedField",
        "name": "deletePost",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "postHeader_deletePostMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Post",
        "kind": "LinkedField",
        "name": "deletePost",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "deleteRecord",
            "key": "",
            "kind": "ScalarHandle",
            "name": "id"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "00a6bc439116a80c81973232f1e6aa19",
    "id": null,
    "metadata": {},
    "name": "postHeader_deletePostMutation",
    "operationKind": "mutation",
    "text": "mutation postHeader_deletePostMutation(\n  $id: ID!\n) {\n  deletePost(id: $id) {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "2c56d2085d79eaa008a5cbaeeea3fb06";

export default node;
